export const SET_QUANT_NAO_LIDAS = 'SET_QUANT_NAO_LIDAS';